import axios from "axios";

import { ApiService } from "../../../../servicios/api.service";
import LocalStorageKeys from "../../../../data/localStorageKeys";

export class ComercioSubscriptionApi {
  static endPoint = "sub-comercio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static async isAfiliadoSubscribedToComercio(afiliadoId, comercioId) {
    const response = await axios.get(
      `${this.BasePath}subscribed/${afiliadoId}/${comercioId}`,
      this.Config
    );

    return response.data;
  }

  static async subscribe(dto) {
    const response = await axios.post(this.BasePath, dto, this.Config);

    return response.data;
  }

  static async cancelSubscription(afiliadoId, comercioId) {
    await axios.delete(
      `${this.BasePath}${afiliadoId}/${comercioId}`,
      this.Config
    );
  }
}
